import React, { useState } from "react";
import SC from "../FileSearchInterface/style";

import { jobTypes, queryTypes } from "utils/lookUpTable";
import { Button } from "@InnoUI/";
import theme from "@theme/";

import InnoIcons from "@InnoIcons/";
import InteractiveSearchUI from "../InteractiveSearchUI";
import { AIServices } from "utils/helper";

const AddressBookSearchInterface = (props) => {
  const [chatUI, setChatUI] = useState(false);
  const [chatData, setChatData] = useState([]);

  const handleIntractiveSearchClose = () => {
    setChatUI(!chatUI);
  };

  return (
    <>
      <InteractiveSearchUI
        handleIntractiveSearch={handleIntractiveSearchClose}
        setChatData={setChatData}
        jobType={jobTypes.ADDJOURNAL}
        // border={true}
        IsHideCloseIcon={true}
        queryType={queryTypes.addressBook}
      />
    </>
  );
};

export default AddressBookSearchInterface;
